<div class="component-container mat-typography mat-body mat-app-background">
  <div class="application-details">
    <h3>
      Documents Upload Successfully! ( {{contentInfo.appId}} )
    </h3>
    <div class="inner-sec">
      <div class="plan-sec d-flex-between">
        <div class="left-sec">

          <div class="entity-grid item">
            <div class="label">Qualifying Life Event </div>
            <span> : </span>
            <div class="value">{{contentInfo.qualifyingLifeEvent}}</div>
          </div>

          <div class="entity-grid item">
            <div class="label">Date of Life Event </div>
            <span> : </span>
            <div class="value">{{contentInfo.dateOfLifeEvent | date:'MM/dd/yyyy'}}</div>
          </div>

          <div class="entity-grid item">
            <div class="label">Effective Date of Coverage </div>
            <span> : </span>
            <div class="value">{{contentInfo.effectiveDate | date:'MM/dd/yyyy'}}</div>
          </div>

        </div>
        <!-- <div class="right-sec">
          <div class="entity-grid item">
            <div class="label">Submitted Date </div>
            <span> : </span>
            <div class="value">{{ null | date:'MM/dd/yyyy'}}</div>
          </div>
          <div class="entity-grid item">
            <div class="label">Effective Date </div>
            <span> : </span>
            <div class="value">{{null}}</div>
          </div>
        </div> -->
      </div>
      <br/>
      <div>
        <slot name="doc-upload-success-text1"></slot>
      </div>
    </div>
  </div>
</div>
